export default __webpack_public_path__ + "static/media/img-ovato-coin-new.bff7d9e6.jpg";